export default __webpack_public_path__ + "static/4-c12f2610ce357f011ff48150194cbc80.png";